export default __webpack_public_path__ + "static/media/citypost.c6f835a7.ico";